import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import ResetPasswordSuccessController from './reset-password-success.controller';
import SuccessAuth from '../common/successAuth/SuccessAuth';

/**
 * @extends ClockoutController
 * @extends ResetPasswordSuccessController
 * @extends Component
 */
class ResetPasswordSuccess extends Inherit(ResetPasswordSuccessController, Component) {
    render() {
        return (
            <SuccessAuth
                title="Password Reset Complete"
                description="Your password has been successfully updated. You can now sign in with your new password."
                continueButtonText="Sign In"
                continueButtonOnClick={() => this.continueToSignIn()}
            />
        );
    }
}

export default withHooks(ResetPasswordSuccess);

